export default __webpack_public_path__ + "static/media/delete.0e99153d.svg";